function providerLabel(provider) {
  if (provider === 'qbo') return 'QuickBooks Online';
  if (provider === 'shopify') return 'Shopify';
  if (provider === 'xero') return 'Xero';
  return 'your books';
}

var ERROR_COPY = {
  unauthorized: 'We could not confirm your MuseMinded session. Sign in again, then retry the connection.',
  invalid_state: 'This connection attempt did not match the one we started. Please try again from Connections.',
  denied: 'The connection was cancelled before it finished. Nothing was saved.',
  failed: 'Something went wrong while connecting. Nothing was posted to your books.',
  credentials_in_url: 'For your security, connection links cannot carry login credentials. Start again from Connections.',
  start_from_app: 'Start the connection from the Connections page in MuseMinded.',
  no_organization: 'No organization was available to connect. Try again and choose an organization.',
  configuration: 'This connection is not configured yet. Contact MuseMinded support.',
  select_expired: 'That organization choice expired. Start the connection again.',
  already_connected: 'That organization is already connected. Go back and choose a different one if you need to.'
};

function goToConnections($auth, $state) {
  $auth.validateUser().then(function () {
    if ($auth.user && $auth.user.role === 'client') {
      $state.go('client.connectionView.connection', {}, { inherit: false });
    } else {
      $state.go('user.connection.default', {}, { inherit: false });
    }
  }).catch(function () {
    $state.go('login', {}, { inherit: false });
  });
}

function ConnectResultCtrl($auth, $state, $stateParams) {
  'ngInject';

  const vm = this;
  vm.provider = $stateParams.provider || 'xero';
  vm.providerLabel = providerLabel(vm.provider);
  vm.organization = $stateParams.organization || 'your organization';
  vm.reason = $stateParams.reason || 'failed';
  vm.message = ERROR_COPY[vm.reason] || ERROR_COPY.failed;

  vm.continue = function () {
    goToConnections($auth, $state);
  };

  vm.retry = function () {
    goToConnections($auth, $state);
  };

  vm.signIn = function () {
    $state.go('login', {}, { inherit: false });
  };
}

export { providerLabel, ERROR_COPY, goToConnections };

export default {
  name: 'ConnectResultCtrl',
  fn: ConnectResultCtrl
};
